import { computed, ComputedRef } from 'vue'

import localeToConditionsUrl from "../../../config/localeToConditionsUrl"

// State
import store from "@/vue/planning/store/store"
import { getCookie } from '@/utils/utils'

const conditionsUrl: ComputedRef<string> = computed(() => {
    const locale: string = store.getters['locale']
    let formattedLocale: string = locale.replaceAll("-", "_")
    if (formattedLocale === "fr_FR_CSE" && getCookie("companyLang") === "nl") {
        formattedLocale = "nl_NL_CSE";
    }
    const url = localeToConditionsUrl[formattedLocale]
    if (!url) throw new Error("could not get conditions url for locale: " + formattedLocale)
    return url + `?ts=${Date.now()}`    
})

export default conditionsUrl